class IwbOptions extends HTMLElement {
  connectedCallback() {
    this.makeSelect = this.querySelector('[data-iwb-make]');
    this.modelSelect = this.querySelector('[data-iwb-model]');

    if (!this.makeSelect || !this.modelSelect) return;

    this.catalog = this.parseCatalog(this.dataset.catalog || '');
    this.populateMakes();
    this.makeSelect.addEventListener('change', this.handleMakeChange);
  }

  disconnectedCallback() {
    this.makeSelect?.removeEventListener('change', this.handleMakeChange);
  }

  parseCatalog(rawCatalog) {
    const catalog = new Map();

    rawCatalog.split(/\r?\n/).forEach((line) => {
      const cleanedLine = line.trim();
      if (!cleanedLine || cleanedLine.startsWith('#')) return;

      const separatorIndex = cleanedLine.indexOf('|');
      if (separatorIndex === -1) return;

      const make = cleanedLine.slice(0, separatorIndex).trim();
      const model = cleanedLine.slice(separatorIndex + 1).trim();
      if (!make || !model) return;

      if (!catalog.has(make)) catalog.set(make, []);
      const models = catalog.get(make);
      if (!models.includes(model)) models.push(model);
    });

    return catalog;
  }

  populateMakes() {
    this.makeSelect.querySelectorAll('option:not([value=""])').forEach((option) => option.remove());

    this.catalog.forEach((_models, make) => {
      this.makeSelect.add(new Option(make, make));
    });

    if (this.catalog.size === 0) {
      this.makeSelect.disabled = true;
      this.modelSelect.disabled = true;
      this.querySelector('[data-iwb-empty]')?.removeAttribute('hidden');
    }
  }

  handleMakeChange = () => {
    const selectedMake = this.makeSelect.value;
    const models = this.catalog.get(selectedMake) || [];

    this.modelSelect.querySelectorAll('option:not([value=""])').forEach((option) => option.remove());
    models.forEach((model) => this.modelSelect.add(new Option(model, model)));

    this.modelSelect.value = '';
    this.modelSelect.disabled = models.length === 0;
  };
}

if (!customElements.get('iwb-options')) {
  customElements.define('iwb-options', IwbOptions);
}
